import { AxiosRequestConfig } from "axios";
import { appendQueryToUrl } from "@/utils";
import { QueryParamsForGetRequest } from "@/utils/types";
import {
  NewsContentPageResponse,
  NewsResponse,
  getNewsEndpoint,
  getNewsPageContentEndpoint,
  http,
  NewsContentPageResponseSchema,
} from "@/services";

export const requestNews = (
  email: QueryParamsForGetRequest,
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getNewsEndpoint, email);

  return http.post<NewsResponse>(url, undefined, config);
};

export const requestNewsPageContent = (
  params: QueryParamsForGetRequest,
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getNewsPageContentEndpoint, params);

  return http.get<NewsContentPageResponse>(
    url,
    undefined,
    config,
    undefined,
    NewsContentPageResponseSchema,
  );
};
